import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, of } from "rxjs";

/**
 * Estratégia de preloading seletivo.
 * Apenas rotas marcadas com `data: { preload: true }` serão carregadas em background,
 * e somente após o usuário estar autenticado.
 * As demais permanecem lazy-loaded sob demanda.
 */
@Injectable({ providedIn: "root" })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  private get isLoggedIn(): boolean {
    return (
      JSON.parse(localStorage.getItem("loggedIn") || "false") &&
      !!localStorage.getItem("modulos")
    );
  }

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.["preload"] === true && this.isLoggedIn)
      return load();
    return of(null);
  }
}
